import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import firebase from "firebase";
import "rxjs/add/observable/fromPromise";
import { Observable } from "rxjs/Observable";
import { HistoryData } from "./history";

@Injectable()
export class CheckInData {
  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
  ) { }

  public userHasCheckIn(
    client: string,
    eventId: string,
    userId: string,
  ) {
    return this.afDb
    .object(`Clients/${client}/Events/${eventId}/CheckIn/${userId}`)
    .valueChanges();
  }

  public checkInUser(
    client: string,
    eventId: string,
    userId: string,
  ) {
    const check =  new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(`Clients/${client}/Events/${eventId}/CheckIn/` + userId)
        .set({id: userId, checkInDate: firebase.database.ServerValue.TIMESTAMP})
        // TODO: Fix resolve .set to .update
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });

    return Observable.fromPromise(check);
  }



}



// WEBPACK FOOTER //
// ./src/providers/checkIn.ts